import { render, staticRenderFns } from "./program-card@.vue?vue&type=template&id=9f15ad8c&scoped=true&"
import script from "./program-card@.vue?vue&type=script&lang=ts&"
export * from "./program-card@.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f15ad8c",
  null
  
)

export default component.exports